<template>
  <section id="shopWearParts">
    <div id="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/" tag="a">Home</router-link></li>
          <li>
            <router-link to="/rfq/create" tag="a">Create New Quote</router-link>
          </li>
          <li class="last">Choose Assembly</li>
        </ul>
      </div>
    </div>

    <div class="container">
      <div class="page-heading-row">
        <h1>{{ pageTitle }}</h1>
        <div class="page-heading-po" v-if="poNumber">
          <span class="po-badge-label">Quote Reference</span>
          <span class="po-badge-value">{{ poNumber }}</span>
        </div>
      </div>

      <div class="row align-items-center mb-4">
        <div class="col-12 mb-4 mb-lg-0">
          <b-form>
            <div class="row mb-4 align-items-end">
              <div class="col-md-4 mb-4 mb-md-0">
                <label for="Machine">Select Machine</label>
                <div
                  class="ui fluid search selection dropdown"
                  id="MachineSelect"
                >
                  <input
                    type="hidden"
                    name="machine"
                    v-model="machineId"
                    id="Machine"
                    @change="onMachineChange"
                  />
                  <div class="default text">Select Machine</div>
                  <i class="dropdown icon"></i>
                  <div class="menu">
                    <div
                      class="item"
                      v-for="machine in machines"
                      :key="machine.companyMachineId"
                      v-bind:data-value="machine.value"
                    >
                      {{ machine.text }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-4 mb-md-0">
                <label for="Assembly">Select Assembly</label>
                <div
                  class="ui fluid search selection dropdown"
                  id="AssemblySelect"
                >
                  <input
                    type="hidden"
                    name="assembly"
                    v-model="assemblyId"
                    id="Assembly"
                    @change="onAssemblyChange"
                  />
                  <div class="default text">Select Assembly</div>
                  <i class="dropdown icon"></i>
                  <div class="menu">
                    <div
                      class="item"
                      v-for="assembly in assemblies"
                      :key="assembly.value"
                      v-bind:data-value="assembly.value"
                    >
                      {{ assembly.text }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-4 mb-md-0">
                <label for="Assembly">Jump to Sub Assembly</label>

                <div
                  class="ui fluid search selection dropdown"
                  id="WearPart"
                >
                  <input
                    type="hidden"
                    name="assembly"
                    v-model="wearPartId"
                    id="WearPart"
                    @change="onWearPartChange"
                  />

                  <div class="default text">Select Sub Assembly</div>

                  <i class="dropdown icon"></i>

                  <div class="menu" v-if="showConfiguredWear">
                    <div
                      class="item"
                      v-for="assembly in wearParts"
                      :key="assembly.assemblyId"
                      v-bind:data-value="assembly.assemblyId"
                    >
                      {{ assembly.assemblyName }}
                    </div>
                  </div>
                  <div class="menu" v-else>
                    <div
                      class="item"
                      v-for="assembly in subAssemblies"
                      :key="assembly.assemblyId"
                      v-bind:data-value="assembly.text"
                    >
                      {{ assembly.text }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-4 mb-md-0">
                <label for="configuredParts"> </label>
                <b-form-checkbox
                  id="configuredParts"
                  v-model="showConfiguredWear"
                  name="configuredParts"
                  value="true"
                  unchecked-value="false"
                  @change="changeConfigure($event)"
                >
                  Configured Wear Parts Only
                  <span>Deselect for all parts</span>
                </b-form-checkbox>
              </div>
            </div>
          </b-form>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 mb-4 mb-md-0">
          <div class="assemblyImg" v-if="assemblyId">
            <img
              v-if="image != null"
              :src="image"
              class="assembly-preview-img"
              @click="openImageModal(image)"
            />
            <img
              v-else
              src="../../../assets/img/jc-steele-placehold.jpg"
              alt="JC Steele"
              class="assembly-preview-img"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showImageModal"
      class="custom-image-modal"
      @click="closeImageModal"
    >
      <div class="custom-image-modal-inner" @click.stop>
        <button
          type="button"
          class="custom-image-close"
          @click="closeImageModal"
          aria-label="Close"
        >
          ×
        </button>

        <div
          class="diagram-zoom-wrap"
          @wheel.prevent="handleWheel"
          @mousedown="startDrag"
        >
          <img
            :src="modalImage"
            class="imagepreview"
            :style="imageTransformStyle"
            @dragstart.prevent
          />
        </div>

        <div class="custom-image-controls">
          <button type="button" class="btn btn-secondary" @click="zoomOut">
            -
          </button>
          <button type="button" class="btn btn-secondary" @click="zoomIn">
            +
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="resetZoom"
          >
            Reset
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="closeImageModal"
          >
            Close
          </button>
        </div>
      </div>
    </div>

    <b-form id="assemblyForm" @submit.prevent="">
      <div id="assemblyList">
        <div class="container">
          <div class="wearParts" v-if="showConfiguredWear == true">
            <div class="row mb-4">
              <div class="col-12">
                <h2>Select Wear Parts for {{ description }}</h2>
              </div>
            </div>

            <div
              class="assembly-card"
              v-for="assembly in wearParts"
              :key="assembly.assemblyId"
              :id="`parts-${assembly.assemblyId}`"
            >
              <!-- Card header — always visible, click to toggle.
                   Contains assembly name + machine, parts count,
                   and an expand chevron. The whole row is the
                   click target (not just the chevron) so the
                   header has a generous tap area. -->
              <button type="button"
                      class="assembly-card-header"
                      :class="{ 'is-open': isAssemblyExpanded(assembly.assemblyId) }"
                      @click="toggleAssembly(assembly.assemblyId)"
                      :aria-expanded="isAssemblyExpanded(assembly.assemblyId) ? 'true' : 'false'">
                <span class="assembly-card-chev">
                  {{ isAssemblyExpanded(assembly.assemblyId) ? '−' : '+' }}
                </span>
                <span class="assembly-card-titles">
                  <span class="assembly-card-name">
                    {{ assembly.assemblyName }}
                  </span>
                  <span class="assembly-card-machine">
                    {{ assembly.machineName }}
                  </span>
                </span>
                <span class="assembly-card-count">
                  {{ assembly.parts ? assembly.parts.length : 0 }}
                  {{ (assembly.parts && assembly.parts.length === 1) ? 'part' : 'parts' }}
                </span>
              </button>

              <!-- Body — parts table only renders when the
                   user expands the card. Hidden by default so
                   the page stays short on machines with many
                   assemblies. -->
              <div class="assembly-card-body"
                   v-show="isAssemblyExpanded(assembly.assemblyId)">
                <b-table
                  stacked="lg"
                  :fields="partsFields"
                  :items="assembly.parts"
                >
                  <template v-slot:cell(item)="data">
                    <div class="nowrap">
                      {{ data.item.item }}
                    </div>
                    <div style="display: none">
                      {{ (data.item.machineId = machineId) }}
                    </div>
                    <div style="display: none">
                      {{ (data.item.assemblyId = assemblyId) }}
                    </div>
                  </template>

                  <template v-slot:cell(code)="data">
                    <div class="nowrap part-code-cell">
                      <span>{{ data.item.code }}</span>
                      <!-- Inline wear-eligible chip next to
                           the part code so the discount
                           affordance is visible even on narrow
                           viewports where the dedicated
                           discount column might wrap or
                           overflow. -->
                      <span class="wear-discount-chip"
                            v-if="wearPartIds[data.item.partId || data.item.id]">
                        2% Discount
                      </span>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div class="text-left">
                      {{ data.item.description }}
                    </div>
                  </template>

                  <template v-slot:cell(quantityPerMachine)="data">
                    {{ data.item.quantityPerMachine }}
                  </template>

                  <template v-slot:cell(price)="data">
                    {{ data.item.price | currency }}
                  </template>

                  <template v-slot:cell(quantity)="data">
                    <button
                      class="btn btn-dark"
                      @click="scrollTo()"
                      v-show="data.item.show"
                    >
                      Added
                    </button>
                    <div style="display: none">{{ data.item.show }}</div>
                    <input
                      type="text"
                      v-model="data.item.quantity"
                      placeholder="1"
                      class="table-input"
                      v-show="!data.item.show"
                    />
                    <button
                      v-show="!data.item.show"
                      class="btn btn-dark table-btn"
                      @click="addToPartsList(data.item, true)"
                    >
                      Add
                    </button>
                  </template>

                  <template v-slot:cell(cost)="data">
                    <div style="display: none">
                      {{
                        (data.item.cost = data.item.price * data.item.quantity)
                      }}
                    </div>
                    <div v-if="data.item.cost">
                      {{ data.item.cost | currency }}
                    </div>
                    <div v-else>{{ data.item.price | currency }}</div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div v-else>
            <div
              class="assembly-card"
              v-for="assembly in subAssemblies"
              :key="assembly.value"
              :id="`parts-${assembly.text}`"
            >
              <button type="button"
                      class="assembly-card-header"
                      :class="{ 'is-open': isAssemblyExpanded(assembly.text) }"
                      @click="toggleAssembly(assembly.text)"
                      :aria-expanded="isAssemblyExpanded(assembly.text) ? 'true' : 'false'">
                <span class="assembly-card-chev">
                  {{ isAssemblyExpanded(assembly.text) ? '−' : '+' }}
                </span>
                <span class="assembly-card-titles">
                  <span class="assembly-card-name">
                    {{ assembly.text }}
                  </span>
                </span>
                <span class="assembly-card-count">
                  {{ assembly.parts ? assembly.parts.length : 0 }}
                  {{ (assembly.parts && assembly.parts.length === 1) ? 'part' : 'parts' }}
                </span>
              </button>

              <div class="assembly-card-body"
                   v-show="isAssemblyExpanded(assembly.text)">
                <b-table
                  stacked="lg"
                  :fields="partsFields"
                  :items="assembly.parts"
                >
                  <template v-slot:cell(item)="data">
                    <div class="nowrap">
                      {{ data.item.item }}
                    </div>

                    <div style="display: none">
                      {{ (data.item.machineId = machineId) }}
                    </div>
                    <div style="display: none">
                      {{ (data.item.assemblyId = assemblyId) }}
                    </div>
                  </template>

                  <template v-slot:cell(code)="data">
                    <div class="nowrap part-code-cell">
                      <span>{{ data.item.code }}</span>
                      <span class="wear-discount-chip"
                            v-if="wearPartIds[data.item.partId || data.item.id]">
                        2% Discount
                      </span>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div class="text-left">
                      {{ data.item.description }}
                    </div>
                  </template>

                  <template v-slot:cell(quantityPerMachine)="data">
                    {{ data.item.quantityPerMachine }}
                  </template>

                  <template v-slot:cell(price)="data">
                    {{ data.item.price | currency }}
                  </template>

                  <template v-slot:cell(quantity)="data">
                    <button
                      class="btn btn-dark"
                      @click="scrollTo()"
                      v-show="data.item.show"
                    >
                      Added
                    </button>
                    <div style="display: none">{{ data.item.show }}</div>
                    <input
                      type="number"
                      v-model="data.item.quantity"
                      placeholder="1"
                      class="table-input"
                      v-show="!data.item.show"
                    />
                    <button
                      v-show="!data.item.show && data.item.quantityPerMachine > 0"
                      class="btn btn-dark table-btn"
                      @click="addToPartsList(data.item, false)"
                    >
                      Add
                    </button>
                  </template>

                  <template v-slot:cell(cost)="data">
                    <div style="display: none">
                      {{
                        (data.item.cost = data.item.price * data.item.quantity)
                      }}
                    </div>
                    <div v-if="data.item.cost">
                      {{ data.item.cost | currency }}
                    </div>
                    <div v-else>{{ data.item.price | currency }}</div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="partsList">
        <div class="container">
          <div class="form-btns">
            <div class="row">
              <div class="col-lg-6 offset-lg-6">
                <div class="row">
                  <div class="col-lg-6 mb-lg-0 mb-4"></div>
                  <div class="col-lg-6 mb-lg-0 mb-4">
                    <button class="btn btn-primary" @click="goToCart()">
                      go to cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </section>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();

import "expose-loader?$!expose-loader?jQuery!jquery";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "QuoteShopWearParts",

  computed: {
    imageTransformStyle() {
      return {
        transform: `translate(${this.pointX}px, ${this.pointY}px) scale(${this.scale})`,
        transformOrigin: "center center",
      };
    },
    // Heading adapts to the entry point: a cart "Add Parts" click means the
    // machine is already in the quote cart, so we frame it as adding more
    // parts instead of creating a new quote.
    pageTitle() {
      if (this.isFromCart && this.description) {
        return "Add more parts to your " + this.description;
      }
      return "Create New Quote for " + (this.description || "");
    },
  },

  mounted() {
    window.addEventListener("pageshow", this.handlePageShow);

    // Apply route params FIRST, before getMachinesByCompany() runs — its
    // internal gate checks localStorage.machineIdRFQ, which will be stale or
    // empty unless we mirror the incoming route params to localStorage up
    // front. Otherwise the assemblies API never fires when arriving from the
    // quote-side cart, leaving Select Assembly and the parts list empty.
    if (this.$route.params.fullOrder) {
      this.fullOrder = this.$route.params.fullOrder;
    }

    if (this.$route.params.partsList) {
      this.partsList = [];
      this.poNumber = this.$route.params.number;
      localStorage.poNumberRFQ = this.poNumber;
      this.machineId = this.$route.params.machineId;
      this.assemblyId = this.$route.params.assemblyId;
      this.cartIdRFQ = this.$route.params.id;
      this.configuredWear = this.$route.params.configuredWear;
      this.fullOrder = this.$route.params.fullOrder;
      this.order = this.$route.params.order;

      // Mirror route params to the RFQ-specific localStorage keys that
      // getMachinesByCompany gates on, AND to the non-suffixed key that the
      // machine-dropdown setTimeout reads from.
      if (this.machineId) {
        localStorage.machineIdRFQ = this.machineId;
        localStorage.machineId = this.machineId;
      }
      if (this.assemblyId) localStorage.assemblyIdRFQ = this.assemblyId;

      // Cart-driven entry — machine's already in the cart, so show ALL parts
      // by default (not just configured wear parts). Using the string "false"
      // to match b-form-checkbox's value="true"/unchecked-value="false".
      this.isFromCart = true;
      this.showConfiguredWear = "false";

      // Optional sub-assembly hints for pre-selecting the Jump to Sub
      // Assembly dropdown.
      this.subAssemblyNameToJumpTo =
        this.$route.params.subAssemblyName || "";
      this.subAssemblyIdToJumpTo = this.$route.params.subAssemblyId || "";

      this.updateSubtotal(this.partsList);
    }

    this.getMachinesByCompany();
    this.loadWearPartIds();

    // Pre-select the Machine dropdown once items have rendered. Retry at 1.5s
    // and 3s to cover both fast and slow API responses.
    var self = this;
    setTimeout(function () {
      var mid = localStorage.machineId || self.machineId;
      if (mid) $("#MachineSelect").dropdown("set selected", String(mid));
      $(".ui.dropdown").dropdown({ fullTextSearch: true });
    }, 1500);
    setTimeout(function () {
      var mid = localStorage.machineId || self.machineId;
      if (mid) $("#MachineSelect").dropdown("set selected", String(mid));
    }, 3000);
  },

  beforeDestroy() {
  window.removeEventListener("pageshow", this.handlePageShow);
  window.removeEventListener("mousemove", this.onDrag);
  window.removeEventListener("mouseup", this.stopDrag);
},

  data() {
    return {
      cartIdRFQ: localStorage.cartIdRFQ,
      assemblyId: "",
      machineId: localStorage.machineIdRFQ,
      companyId: localStorage.companyId,
      assembly: "",
      wearPartId: "",
      assemblies: [],
      subassembly: "",
      subAssemblies: [],
      subassemblyId: "",
      machine: "",
      machines: [],
      description: "",
      image: "",
      url: "https://steeleimages.blob.core.windows.net/images/",
      editPoNumber: false,
      subTotal: 0,
      poNumber: localStorage.poNumberRFQ,
      configuredWear: localStorage.configuredWear,
      showConfiguredWear: true,
      // True when the user arrived via "Add Parts" from a quote-side cart
      // row — the heading and the wear-parts checkbox default differently.
      isFromCart: false,
      // Optional sub-assembly hints from the cart's "Add Parts" click.
      // Used to pre-select the "Jump to Sub Assembly" dropdown; silently
      // ignored when no match exists.
      subAssemblyNameToJumpTo: "",
      subAssemblyIdToJumpTo: "",
      fullOrder: "",
      wearParts: [],
      // Map of PartId → true for parts in the company's
      // dbo.Wears table. Drives the green "Eligible for 2%
      // Discount" badge next to each row in the parts table.
      // Loaded on mount via loadWearPartIds. Empty until the
      // load completes — badges fade in as data arrives.
      wearPartIds: {},
      // Which assembly cards are currently expanded. Keyed by
      // assemblyId for wear-parts mode and by assembly.text
      // for sub-assembly mode (matches the existing :id
      // pattern on each card). Default empty so all cards
      // start COLLAPSED — the page used to render every
      // assembly's full parts table inline, producing very
      // long scrollable pages on machines with many
      // assemblies. Now each assembly is a single-row header
      // with a count + total, and the parts table only
      // renders when the user clicks to expand.
      expandedAssemblies: {},
      partsFields: [
        "item",
        "code",
        "description",
        { key: "quantityPerMachine", label: "QTY PER MACHINE" },
        "price",
        { key: "quantity", label: "Cart Qty" },
        "cost",
        { key: "remove", label: "" },
      ],
      partsList: [],
      showImageModal: false,
      modalImage: "",
      scale: 1,
      minScale: 1,
      maxScale: 5,
      pointX: 0,
      pointY: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
    };
  },

  methods: {

    handlePageShow(event) {
  const navEntries = performance.getEntriesByType("navigation");
  const navType = navEntries.length ? navEntries[0].type : "";

  if (event.persisted || navType === "back_forward") {
    window.location.reload();
  }
},

    openImageModal(src) {
      this.modalImage = src;
      this.resetZoom();
      this.showImageModal = true;
    },

    closeImageModal() {
      this.showImageModal = false;
      this.resetZoom();
    },

    resetZoom() {
      this.scale = 1;
      this.pointX = 0;
      this.pointY = 0;
    },

    zoomIn() {
      this.scale = Math.min(this.maxScale, this.scale + 0.25);
    },

    zoomOut() {
      this.scale = Math.max(this.minScale, this.scale - 0.25);
      if (this.scale === 1) {
        this.pointX = 0;
        this.pointY = 0;
      }
    },

    handleWheel(event) {
      const delta = event.deltaY < 0 ? 0.2 : -0.2;
      const nextScale = Math.min(
        this.maxScale,
        Math.max(this.minScale, this.scale + delta)
      );

      this.scale = nextScale;

      if (this.scale === 1) {
        this.pointX = 0;
        this.pointY = 0;
      }
    },

    startDrag(event) {
      if (this.scale <= 1) return;

      this.isDragging = true;
      this.startX = event.clientX - this.pointX;
      this.startY = event.clientY - this.pointY;

      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
    },

    onDrag(event) {
      if (!this.isDragging) return;

      this.pointX = event.clientX - this.startX;
      this.pointY = event.clientY - this.startY;
    },

    stopDrag() {
      this.isDragging = false;
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
    },

    // Pull THIS company's wear-eligible PartIds (its dbo.Wears
    // = the Account Setup wear list). Used by the parts-table
    // template to show the green "Eligible for 2% Discount"
    // badge next to wear parts. The badge must reflect the
    // customer's OWN wear parts, not the global wear-eligible
    // catalog — so use the company-scoped endpoint keyed by
    // localStorage.companyId. Defensive against missing API
    // method (older builds), missing companyId, non-array
    // response, network failure (or a pre-deploy 404 on the
    // new endpoint) — all paths fall back to an empty map (no
    // badges, no crash).
    loadWearPartIds() {
      if (!apiService.getCompanyWearPartIds) {
        console.warn("[ShopWearParts] loadWearPartIds skipped — apiService.getCompanyWearPartIds missing (older FeApiService.js deployed)");
        this.wearPartIds = {};
        return;
      }
      var companyId = localStorage.companyId || "";
      if (!companyId) {
        console.warn("[ShopWearParts] loadWearPartIds skipped — no companyId yet");
        this.wearPartIds = {};
        return;
      }
      var self = this;
      apiService
        .getCompanyWearPartIds(companyId)
        .then(function (data) {
          // Tolerate several response shapes the backend
          // could return:
          //   [123, 456]                      flat numeric array (expected)
          //   [{partId: 123}, ...]            objects with partId
          //   [{id: 123}, ...]                Part entity objects
          //   [{PartId: 123}, ...]            PascalCase casing
          var map = {};
          if (Array.isArray(data)) {
            data.forEach(function (item) {
              if (item == null) return;
              var id;
              if (typeof item === "number" || typeof item === "string") {
                id = item;
              } else if (typeof item === "object") {
                id = item.partId || item.PartId || item.id || item.Id;
              }
              if (id != null) map[id] = true;
            });
          } else {
            console.warn("[ShopWearParts] getCompanyWearPartIds returned non-array:", data);
          }
          self.wearPartIds = map;
          console.log("[ShopWearParts] loaded", Object.keys(map).length, "wear part ids for companyId", companyId);
        })
        .catch(function (err) {
          console.warn("[ShopWearParts] could not load wear part ids:", err);
          self.wearPartIds = {};
        });
    },

    // Accordion helpers — flip a per-assembly expand state
    // so the parts table only renders when the user clicks
    // the card header. Vue.set is required because we're
    // adding new keys to a reactive object that didn't have
    // them at init time; without it, the template wouldn't
    // re-render when a key first goes from undefined → true.
    isAssemblyExpanded(key) {
      return !!this.expandedAssemblies[key];
    },
    toggleAssembly(key) {
      var current = !!this.expandedAssemblies[key];
      this.$set(this.expandedAssemblies, key, !current);
    },

    fail(err) {
      this.$bvToast.toast(
        err.error.response.data.traceId
          ? "TraceID: " + err.error.response.data.traceId
          : err.error.response.data,
        {
          title: err.error.response.data.title,
          autoHideDelay: 10000,
          appendToast: false,
          variant: "danger",
          solid: true,
        }
      );
    },

    getMachinesByCompany() {
      apiService
        .getMachinesByCompany({ id: localStorage.companyId })
        .then((data) => {
          this.machines = data;
          setTimeout(function() {
            $("#MachineSelect").dropdown("set selected", this.machineId);
            $(".ui.dropdown").dropdown({ fullTextSearch: true });
          }, 2000);
        });

      if (localStorage.machineIdRFQ) {
        this.getSelectItemsByCompanyMachine();
        this.machineDetails(this.machineId);
      }
    },

    getSelectItemsByCompanyMachine() {
      apiService
        .getSelectItemsByCompanyMachine({
          id: this.machineId,
        })
        .then((request) => {
          this.assemblies = request;

          if (this.assemblyId != "") {
            // Semantic UI's dropdown widget doesn't watch v-model — tell it
            // explicitly which assembly to show. $nextTick fires after Vue
            // renders the items; the 600ms safety retry covers slower renders.
            var self = this;
            this.$nextTick(function () {
              var aid = self.assemblyId;
              if (aid) {
                $("#AssemblySelect").dropdown(
                  "set selected",
                  String(aid)
                );
              }
            });
            setTimeout(function () {
              var aid = self.assemblyId;
              if (aid) {
                $("#AssemblySelect").dropdown(
                  "set selected",
                  String(aid)
                );
              }
            }, 600);

            if (this.showConfiguredWear == true) {
              this.getWearParts();
            } else {
              this.getSubAssembly();
            }
          }
          $(".ui.dropdown").dropdown({ fullTextSearch: true });
        })
        .catch((err) => this.fail(err));
    },

    onMachineChange(event) {
      this.machineId = event.target.value;
      localStorage.machineId = this.machineId;
      this.assemblyId = "";
      this.wearPartId = "";
      this.wearParts = [];
      setTimeout(() => {
        $("#AssemblySelect").dropdown("clear");
        $("#WearPart").dropdown("clear");
      }, 100);
      this.getSelectItemsByCompanyMachine(this.machineId);
      this.machineDetails(this.machineId);
    },

    onAssemblyChange(event) {
      this.assemblyId = event.target.value;
      this.wearPartId = "";
      this.wearParts = [];
      setTimeout(() => {
        $("#WearPart").dropdown("clear");
      }, 100);

      if (this.showConfiguredWear == true) {
        this.getWearParts();
      } else {
        this.getSubAssembly();
      }
    },

    getSubAssembly() {
      apiService
        .getAssemblyDetails({
          id: this.assemblyId,
        })
        .then((request) => {
          if (request.imagePath != null) {
            this.image = this.url + request.imagePath;
          } else {
            this.image = null;
          }
        })
        .catch((err) => this.fail(err));

      apiService
        .getAssemblyWithParts({
          id: this.assemblyId,
        })
        .then((request) => {
          this.selectItemsSuccessful(request);
        })
        .catch((err) => this.fail(err));
    },

    selectItemsSuccessful(request) {
      this.subAssemblies = request;
      this.subAssemblies.forEach((item) => {
        item.parts.forEach((part) => {
          part.quantity = part.quantityPerMachine;
        });
      });

      // Pre-select the "Jump to Sub Assembly" dropdown if a name hint was
      // passed from the cart. This branch uses data-value="text" (the
      // assembly name), so we match by name. No-ops silently when no match.
      var self = this;
      var subName = self.subAssemblyNameToJumpTo;
      if (subName) {
        var tryPreselect = function () {
          var match = (self.subAssemblies || []).find(function (a) {
            return a && a.text === subName;
          });
          if (match) {
            $("#WearPart").dropdown("set selected", String(subName));
          }
        };
        this.$nextTick(tryPreselect);
        setTimeout(tryPreselect, 600);
      }
    },

    getWearParts() {
      apiService
        .getAssemblyDetails({
          id: this.assemblyId,
        })
        .then((request) => {
          if (request.imagePath != null) {
            this.image = this.url + request.imagePath;
          } else {
            this.image = null;
          }
        })
        .catch((err) => this.fail(err));

      apiService
        .getAssembliesWithWearParts({
          companyMachineId: this.machineId,
          assemblyId: this.assemblyId,
        })
        .then((request) => {
          this.wearPartsSuccessful(request);
        })
        .catch((err) => this.fail(err));
    },

    wearPartsSuccessful(request) {
      this.wearParts = request;
      this.wearParts.forEach((item) => {
        item.parts.forEach((part) => {
          part.quantity = part.quantityPerMachine;
        });
      });
      this.wearParts.sort((a, b) =>
        a.assemblyName.localeCompare(b.assemblyName)
      );

      // In the wear-parts branch, data-value is assembly.assemblyId, so we
      // can match by ID when one is passed from the cart.
      var self = this;
      var subId = self.subAssemblyIdToJumpTo;
      if (subId) {
        var tryPreselect = function () {
          var match = (self.wearParts || []).find(function (a) {
            return a && String(a.assemblyId) === String(subId);
          });
          if (match) {
            $("#WearPart").dropdown("set selected", String(subId));
          }
        };
        this.$nextTick(tryPreselect);
        setTimeout(tryPreselect, 600);
      }
    },

    machineDetails(id) {
      apiService
        .getCompanyMachineDetails({ id: id })
        .then((request) => this.machineSuccessful(request))
        .catch((err) => this.fail(err));
    },

    machineSuccessful(request) {
      this.description = request.description;
    },

    changePoNumber(num) {
      if (num) {
        localStorage.poNumberRFQ = num;
        this.editPoNumber = !this.editPoNumber;
      } else {
        this.$bvToast.toast("Please enter a valid Quote Reference to continue", {
          title: "Warning! Quote Reference field cannot be empty",
          autoHideDelay: 5000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      }
    },

    addToPartsList(part, fromWearParts) {
      this.partsList = [];
      if (!part.quantity) {
        part.quantity = 1;
        part.cost = part.price;
      }

      var idx = $.inArray(part, this.partsList);
      if (idx == -1) {
        this.partsList.push(part);
      } else {
        for (let i in this.partsList) {
          if (this.partsList[i].id == part.id) {
            this.partsList[i].quantity = part.quantity;
            break;
          }
        }
      }
      this.addToCart(part, fromWearParts);
      this.updateSubtotal(this.partsList);
    },

    onWearPartChange(event) {
      const partId = event.target.value;
      const scrollInto = {
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      };
      setTimeout(() => {
        document.getElementById(`parts-${partId}`).scrollIntoView(scrollInto);
      }, 10);
    },

    scrollToTop() {
      document
        .getElementById("mainBody")
        .scrollIntoView({ behavior: "smooth" });
    },

    scrollTo() {
      $("html, body").animate(
        {
          scrollTop: $("#partsList").offset().top,
        },
        500
      );
    },

    removeItem(item) {
      this.subTotal = this.subTotal - item.cost;

      var idx = $.inArray(item, this.partsList);
      this.partsList.splice(idx, 1);
      item.show = false;
    },

    removeAllParts() {
      for (var i in this.partsList) {
        this.partsList[i].show = false;
      }
      this.partsList = [];
      this.subTotal = 0;
    },

    addToCart(part, fromWearParts = false) {
      this.cartIdRFQ = localStorage.cartIdRFQ || this.cartIdRFQ;
      if (this.fullOrder.purchaseOrders) {
        this.fullOrder.purchaseOrders = [];
        var po = this.poNumber;
        var assemblyID = this.assemblyId;
        if (
          this.fullOrder.purchaseOrders.filter(function(e) {
            return e.number == po;
          }).length > 0
        ) {
          if (
            this.fullOrder.purchaseOrders.filter(function(e) {
              return e.assemblyId == assemblyID;
            }).length > 0
          ) {
            for (let i in this.partsList) {
              newPO = {
                assemblyId: this.partsList[i].assemblyId || this.assemblyId,
                machineId: this.machineId,
                parts: [this.partsList[i]],
                Number: this.poNumber,
                configuredWear: true,
              };

              this.fullOrder.purchaseOrders.push(newPO);
            }
          } else {
            for (let i in this.partsList) {
              this.assemblyId = this.partsList[i].assemblyId;
              var newPO = {
                assemblyId: this.partsList[i].assemblyId || this.assemblyId,
                machineId: this.machineId,
                parts: [this.partsList[i]],
                cartId: this.cartIdRFQ,
                Number: this.poNumber,
                configuredWear: true,
              };

              this.fullOrder.purchaseOrders.push(newPO);
            }
          }
          apiService
            .saveCart({
              id: this.cartIdRFQ || 0,
              parts: this.partsList,
              number: this.poNumber,
              machineId: this.machineId,
              purchaseOrders: this.fullOrder.purchaseOrders,
              companyId: this.companyId,
              CreateQuote: true,
            })
            .then((request) => {
              this.saveCartSuccessful(request);
              this.updateBtn(fromWearParts, part);
            })
            .catch((err) => this.fail(err));
        } else {
          for (let i in this.partsList) {
            this.assemblyId = this.partsList[i].assemblyId;
            newPO = {
              assemblyId: this.partsList[i].assemblyId || this.assemblyId,
              machineId: this.machineId,
              parts: [this.partsList[i]],
              cartId: this.cartIdRFQ,
              Number: this.poNumber,
              configuredWear: true,
            };

            this.fullOrder.purchaseOrders.push(newPO);
          }
          apiService
            .saveCart({
              id: this.cartIdRFQ || 0,
              parts: this.partsList,
              number: this.poNumber,
              machineId: this.machineId,
              purchaseOrders: this.fullOrder.purchaseOrders,
              companyId: this.companyId,
              CreateQuote: true,
            })
            .then((request) => {
              this.saveCartSuccessful(request);
              this.updateBtn(fromWearParts, part);
            })
            .catch((err) => this.fail(err));
        }
      } else {
        this.fullOrder = {
          purchaseOrders: [],
        };

        for (let i in this.partsList) {
          newPO = {
            assemblyId: this.partsList[i].assemblyId,
            machineId: this.machineId,
            parts: [this.partsList[i]],
            Number: this.poNumber,
            configuredWear: true,
          };

          this.fullOrder.purchaseOrders.push(newPO);
        }
        apiService
          .saveCart({
            id: this.cartIdRFQ || 0,
            parts: this.partsList,
            number: this.poNumber,
            machineId: this.machineId,
            purchaseOrders: this.fullOrder.purchaseOrders,
            companyId: this.companyId,
            CreateQuote: true,
          })
          .then((request) => {
            this.saveCartSuccessful(request);
            this.updateBtn(fromWearParts, part);
          })
          .catch((err) => this.fail(err));
      }
    },

    saveCartSuccessful(request) {
      localStorage.cartIdRFQ = request.id;
      localStorage.cartLastActivity = Date.now().toString();
      this.fullOrder.purchaseOrders = request.purchaseOrders;
      if (this.$cartBus) {
        this.$cartBus.$emit('cart-updated');
      }
    },

    goToCart() {
      this.$router.push("/cart/rfqsaveditems");
    },

    updateSubtotal() {
      var subTotal = 0;

      this.partsList.forEach((item) => {
        item.cost = item.quantity * item.price;

        subTotal = subTotal + item.cost;

        this.subTotal = subTotal;
      });

      this.subTotal = subTotal;

      this.$forceUpdate(this.subTotal);
    },

    updateBtn(fromWearParts, part) {
      const resultant = fromWearParts ? this.wearParts : this.subAssemblies;
      resultant.forEach(machine => {
        const partToUpdate = machine.parts.find(partItem => partItem.id === part.id);
        if (partToUpdate) {
          this.$set(partToUpdate, "show", true);
        }
      });
    },

    changeConfigure(event) {
      if (event == "true") {
        this.showConfiguredWear = true;
        this.getWearParts();
      } else {
        this.showConfiguredWear = false;
        this.getSubAssembly();
      }
    },
  },
};
</script>

<style scoped>
/* ===== PAGE HEADING + PO BADGE ===== */
.page-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 18px;
}

.page-heading-row h1 {
  margin: 0;
  flex: 1 1 auto;
  min-width: 240px;
}

.page-heading-po {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-left: 3px solid #c0392b;
  border-radius: 6px;
  padding: 8px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.po-badge-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #777;
}

.po-badge-value {
  font-size: 15px;
  font-weight: 700;
  color: #c0392b;
  letter-spacing: 0.3px;
}

@media (max-width: 767.98px) {
  .page-heading-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .page-heading-po {
    width: 100%;
    justify-content: space-between;
  }
}

.assembly-preview-img {
  width: 443px;
  height: 303px;
  cursor: zoom-in;
  object-fit: contain;
}

.custom-image-modal {
  position: fixed;
  z-index: 99999;
  inset: 0;
  background: rgba(0, 0, 0, 0.88);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.custom-image-modal-inner {
  background: #fff;
  width: 95%;
  max-width: 1400px;
  height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.custom-image-close {
  position: absolute;
  top: 10px;
  right: 14px;
  z-index: 2;
  border: none;
  background: transparent;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
}

.diagram-zoom-wrap {
  flex: 1;
  overflow: hidden;
  position: relative;
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f8f8;
}

.diagram-zoom-wrap:active {
  cursor: grabbing;
}

.imagepreview {
  max-width: 95%;
  max-height: 95%;
  user-select: none;
  -webkit-user-drag: none;
  transition: transform 0.05s linear;
}

.custom-image-controls {
  padding: 12px 16px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  background: #fff;
}

/* ===== ASSEMBLY ACCORDION CARDS =====
   Replaces the previous always-expanded list of assembly +
   parts-table sections. Each assembly is now a single card
   that starts collapsed; the parts table only renders when
   the user clicks the header. Visual treatment mirrors the
   card pattern used elsewhere on the site: white surface,
   brand-red top accent, soft shadow, generous padding. */
.assembly-card {
  background: #fff;
  border: 1px solid #ececec;
  border-top: 3px solid #c0392b;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 16px;
  overflow: hidden;
}

.assembly-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  background: transparent;
  border: 0;
  padding: 14px 18px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.15s ease;
}

.assembly-card-header:hover {
  background: #faf5f4;
}

.assembly-card-header:focus {
  outline: none;
  background: #faf5f4;
  box-shadow: inset 0 0 0 2px rgba(192, 57, 43, 0.15);
}

.assembly-card-header.is-open {
  border-bottom: 1px solid #ececec;
}

/* Plus/minus toggle indicator. Brand-red filled circle with
   white glyph so it reads as the primary affordance even at
   a glance. */
.assembly-card-chev {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  background: #c0392b;
  color: #fff;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  font-family: monospace; /* keeps + and - same width */
}

.assembly-card-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0; /* allow text-overflow ellipsis on narrow */
}

.assembly-card-name {
  font-size: 15px;
  font-weight: 700;
  color: #c0392b;
  letter-spacing: 0.2px;
}

.assembly-card-machine {
  font-size: 12px;
  color: #888;
  font-weight: 500;
}

.assembly-card-count {
  font-size: 12px;
  color: #555;
  font-weight: 600;
  background: #f3f3f3;
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

.assembly-card-body {
  padding: 8px 18px 16px 18px;
}

.assembly-card-body .b-table,
.assembly-card-body .table {
  margin-bottom: 0;
}

/* ===== WEAR DISCOUNT CHIP (in-table) =====
   Smaller, shorter-text variant of the search page's badge
   so it fits inside a parts-table code cell. The flex wrap
   on .part-code-cell lets the chip drop to a new line on
   narrow viewports rather than overflowing. */
.part-code-cell {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.wear-discount-chip {
  display: inline-block;
  padding: 1px 6px;
  background: #e8f5e9;
  border: 1px solid #2e7d32;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #2e7d32;
  white-space: nowrap;
  line-height: 1.4;
}
</style>